export default function ExecutiveCard({
  title,
  value,
  subtitle,
  accent = "default",
  valueClassName = "text-3xl font-bold",
}) {

  const accentStyles = {
    default: "text-slate-900",
    success: "text-green-700",
    warning: "text-amber-700",
    danger: "text-red-700",
    info: "text-blue-700",
  };

  return (
    <div className="bg-white border border-slate-200 rounded-2xl p-5 shadow-sm">
      <p className="text-xs uppercase tracking-wide text-slate-500">
        {title}
      </p>

      <div className={`mt-2 ${valueClassName} ${accentStyles[accent]}`}>
        {value}
      </div>

      {subtitle && (
        <p className="mt-2 text-sm text-slate-500 leading-relaxed">
          {subtitle}
        </p>
      )}
    </div>
  );
}
